import auth from "../../firebase/auth";
import api from "../../api";
import { createSuccess, createError } from "../../libs/flash-messages";

const findIndex = (state, id) => {
   return state.users.findIndex(user => {
      return user._id === id;
   });
}

const state = {
   filters: {
      name: "",
      status: "any",
      sort: "a-z"
   },
   users: null
}

const getters = {
   getUsers(state) {
      return state.users
   },
   getFilteredUsers(state) {
      if (state.users) {
         return state.users.filter(user => {
            if (state.filters.name) {
               return user.name.toLowerCase().includes(state.filters.name.toLowerCase());
            }
            return user;
         }).filter(user => {
            if (state.filters.status === "any") {
               return user;
            }
            if (state.filters.status === "active") {
               return user.isActive;
            } else {
               return !user.isActive;
            }
         }).sort((a, b) => {
            if (state.filters.sort === "a-z") {
               if (a.name > b.name) {
                  return 1;
               } else if (a.name < b.name) {
                  return -1;
               } else {
                  return 0;
               }
            } else {
               if (a.name > b.name) {
                  return -1;
               } else if (a.name < b.name) {
                  return 1;
               } else {
                  return 0;
               }
            }
         });
      } else {
         return [];
      }
   }
}

const actions = {
   async startSetUsers({ commit, rootState }) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         const users = await api.axiosGet(`/api/compliance/compliance-users/all`, token);
         commit("SET_USERS", users);
      } catch (err) {
         createError("Could Not Fetch Users", err)
      }
   },
   startUnsetUsers({ commit }) {
      commit('SET_USERS', null);
   },
   startSetUserFilters({ commit }, form) {
      commit('SET_NAME_FILTER', form.name);
      commit('SET_STATUS_FILTER', form.status);
      commit('SET_SORT_FILTER', form.sort);
   },
   async startCreateUser({ rootState }, form) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         const newUser = await api.axiosPost(`/api/compliance/compliance-users`, form, token);
         this._vm.$socket.io.nsps["/compliance"].emit("CREATE_USER", newUser);
         createSuccess(`Successfully Created: ${newUser.name}`);
      } catch (err) {
         createError("Failed to Create", err);
      }
   },
   async startUpdateUser({ rootState }, form) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      const id = form._id;
      try {
         await api.axiosPut(`/api/compliance/compliance-users/${id}`, form, token);
         this._vm.$socket.io.nsps["/compliance"].emit("UPDATE_USER", form);
         createSuccess(`Successfully Updated: ${form.name}`);
      } catch (err) {
         createError("Failed to Update", err);
         return Promise.reject(err);
      }
   },
   async startDeleteUser({ rootState }, id) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         await api.axiosDelete(`/api/compliance/compliance-users/${id}`, token);
         this._vm.$socket.io.nsps["/compliance"].emit("DELETE_USER", id);
         createSuccess("Successfully Deleted User")
      } catch (err) {
         createError("Failed to Delete User", err);
         return Promise.reject(err);
      }
   }
}

const mutations = {
   SET_USERS(state, users) {
      return state.users = users;
   },
   SET_NAME_FILTER(state, name) {
      return state.filters.name = name;
   },
   SET_STATUS_FILTER(state, status) {
      return state.filters.status = status;
   },
   SET_SORT_FILTER(state, sort) {
      return state.filters.sort = sort;
   },
   SOCKET_COMP_CREATE_USER(state, user) {
      if (state.users) {
         state.users.push(user);
      } else {
         state.users = [user];
      }
   },
   SOCKET_COMP_UPDATE_USER(state, form) {
      const userFound = findIndex(state, form._id);
      state.users.splice(userFound, 1, form);
   },
   SOCKET_COMP_DELETE_USER(state, id) {
      const userFound = findIndex(state, id);
      state.users.splice(userFound, 1);
   }
}

export default {
   state,
   getters,
   actions,
   mutations
}